import React, { Fragment } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { history, store } from "../../../../../store/store";
import { ROUTE_CLIENT_USER_VIEW } from "../../../../../config/routes";
import { ACL, USER_DELETE_STATUSES } from "../../../../../config/constants";
import { hideNotification } from '../../../../../store/actions/notification';

function ViewClient(props) {
  const { index, user } = props;

  if (! ACL.CLIENT.USERS.VIEW.hasAccess()) {
    return null;
  }

  const shouldDisplay = (user) => {
    return (!user || USER_DELETE_STATUSES.includes(user.status)) ? false : true;
  }

  if (! shouldDisplay(user)) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer mr-2 link-icon-color"
        id={`view-icon-${index}`}
        onClick={(e) => {
          e.preventDefault();
          store.dispatch(hideNotification());
          let url = ROUTE_CLIENT_USER_VIEW;
          url = url.replace(":userId", user.id);
          history.push(url);
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="mr-2 cursor-pointer"
          pointerEvents="none"
          icon={faEye}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`view-icon-${index}`}
        boundariesElement="viewport"
        positionFixed
      >
        <FormattedMessage id="button.view" />
      </UncontrolledTooltip>
    </Fragment>
  );
}

export { ViewClient };
